import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/static/RouletteRectangle0.png'
import _imports_1 from '@/assets/images/static/RouletteRectangle1.png'
import _imports_2 from '@/assets/images/static/RouletteRectangle2.png'


const _hoisted_1 = { class: "global-wrapper roulette-wrapper" }
const _hoisted_2 = { class: "global-container roulette-container" }
const _hoisted_3 = { class: "roulette" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "roulette__rectangle-0",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "roulette__rectangle-1",
  src: _imports_1
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "roulette__rectangle-2",
  src: _imports_2
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          class: "roulette-circle",
          ref: "roulette",
          src: $props.imgCircleUrl
        }, null, 8, ["src"]),
        _createVNode("img", {
          class: "roulette-point",
          src: $props.imgPointUrl,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.playGame && $setup.playGame(...args)))
        }, null, 8, ["src"])
      ]),
      ($props.haveCube)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}